export const ru = {
    category: 'Категории',
    selected: 'Выбранные',
    zones: 'Зоны'
};
